import { HoldingsProjectForm } from "./Main";

/*
ホールディングス案件登録画面(事業者情報)
 */
export const Register = () => {
  return <HoldingsProjectForm />;
};
